exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "._226kRjufP3DcR2P1QhuqV-{-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center;display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-pack:end;-webkit-justify-content:flex-end;-moz-box-pack:end;-ms-flex-pack:end;justify-content:flex-end}._2zYX7-ScH9odHE8LAOuawi{cursor:pointer}", ""]);

// exports
exports.locals = {
	"colorSideNav": "#008a8a",
	"DetailLinkTd_content": "_226kRjufP3DcR2P1QhuqV-",
	"DetailLinkTd_arrowRight": "_2zYX7-ScH9odHE8LAOuawi"
};


//////////////////
// WEBPACK FOOTER
// ../node_modules/css-loader?{"root":".","modules":true,"import":false,"importLoaders":1}!../node_modules/postcss-loader/lib?{"config":{"path":"/var/lib/jenkins/workspace/build-omni-operation-ui_develop/node_modules/omni-common-ui/postcss.config.js"}}!./components/TableView/Tds/DetailLinkTd/style.postcss
// module id = 1282
// module chunks = 0